<template>
	<div class=" padding-left-30 padding-right-30 padding-bottom-30">
		<div class="vctb-list">
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==0}" @click="vctbIndex=0">
				裁判文书({{document_group.totalnum}})
			</div>
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==1}" @click="vctbIndex=1">
				法院公告({{courtnotice_group.totalnum}})
			</div>
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==2}" @click="vctbIndex=2">
				开庭公告({{opennotice_group.totalnum}})
			</div>
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==3}" @click="vctbIndex=3">
				立案信息({{filing_group.totalnum}})
			</div>
		</div>
		<div class="padding-left-10 padding-right-10 ">

			<template v-if="vctbIndex==0">
				<div class="box5 box2_cc">
					<div class="box5_text2 text-bold">案件名称</div>
					<div class="box5_text2 text-bold">案由关键字 </div>
					<div class="box5_text2 text-bold">原告身份</div>
					<div class="box5_text2 text-bold">被告身份</div>
					<div class="box5_text2 text-bold">法院名称</div>
					<div class="box5_text2 text-bold   width-130  " style="flex:none;">裁判发布日期</div>
					<div class="box5_text2 text-bold justify-center  width-80  " style="flex:none;">案件详情</div>
				</div>
				<div v-for="(item, index) in document_list" :key="index" class="box5">
					<div class="box5_text2">{{ item.title||"--" }} </div>
					<div class="box5_text2">{{ item.caseCause ||"--" }} </div>
					<div class="box5_text2">{{ item.plaintiffs||"--"  }} </div>
					<div class="box5_text2">{{ item.defendants||"--"  }}</div>
					<div class="box5_text2">{{ item.court||"--"  }}</div>
					<div class="box5_text2  width-130  " style="flex:none;">
						{{ item.date?dayjs(Number(item.date)*1000).format('YYYY-MM-DD')  :"--" }}
					</div>
					<div class="box5_text2  justify-center  width-80  " style="flex:none;">
						<span class="cpoint" style="color: #0070c0;" @click="showDialog(item,'document')">详情</span>
					</div>
				</div>
				<div class="padding-bottom-40" v-if="!document_list.length">
					<nomore></nomore>
				</div>

				<div class=" text-right" style="padding: 10px 0">
					<el-pagination background :page-size="document_group.pagesize" :page-sizes="pageSizes"
						:hide-on-single-page="false" layout="prev, pager, next,sizes"
						@size-change="handleSizeChange($event,'document')"
						@current-change="handleCurrentChange($event,'document')"
						:current-page="document_group.currentPage" :total="document_group.totalnum">
					</el-pagination>
				</div>
			</template>
			<template v-if="vctbIndex==1">

				<div v-if="detail">
					<div class="box5 box2_cc">
						<div class="box5_text2 text-bold">原告身份</div>
						<div class="box5_text2 text-bold">被告身份 </div>
						<div class="box5_text2 text-bold">法院公告类型</div>
						<div class="box5_text2 text-bold">公告人</div>
						<div class="box5_text2 text-bold width-100" style="flex:none;">法院公告日期</div>
						<div class="box5_text2 text-bold justify-center  width-80  " style="flex:none;">案件详情</div>
					</div>
					<!-- detail.majorpeople -->
					<div v-for="(item, index) in courtnotice_list" :key="index" class="box5">
						<div class="box5_text2">
							{{ item.plaintiffs ||"--" }}
						</div>
						<div class="box5_text2">{{ item.defendants||"--" }} </div>
						<div class="box5_text2">{{ item.type||"--" }} </div>
						<div class="box5_text2">{{ item.court||"--" }}</div>
						<div class="box5_text2  width-100  " style="flex:none;">{{ item.date||"--" }}</div>
						<div class="box5_text2 justify-center  width-80  " style="flex:none;">
							<span class="cpoint" style="color: #0070c0;"
								@click="showDialog(item,'courtnotice')">详情</span>
						</div>
					</div>
					<div class="padding-bottom-40" v-if="!courtnotice_list.length">
						<nomore></nomore>
					</div>
					<div class="text-right" style="padding: 10px 0">
						<el-pagination background :page-size="courtnotice_group.pagesize" :page-sizes="pageSizes"
							:hide-on-single-page="false" layout="prev, pager, next,sizes"
							@size-change="handleSizeChange($event,'courtnotice')"
							@current-change="handleCurrentChange($event,'courtnotice')"
							:current-page="courtnotice_group.pagesize.currentPage" :total="courtnotice_group.totalnum">
						</el-pagination>
					</div>
				</div>
			</template>

			<template v-if="vctbIndex==2">
				<div class="box5 box2_cc">
					<div class="box5_text2 text-bold">案件名称</div>
					<div class="box5_text2 text-bold">原告身份</div>
					<div class="box5_text2 text-bold">被告身份 </div>
					<div class="box5_text2 text-bold">开庭公告发布日期</div>
					<div class="box5_text2 text-bold">公告人</div>
					<div class="box5_text2 text-bold ">开庭日期(开庭公告)</div>
					<div class="box5_text2 text-bold justify-center width-80" style="flex:none;">案件详情</div>
				</div>
				<!-- detail.majorpeople -->
				<div v-for="(item, index) in opennotice_list" :key="index" class="box5">
					<div class="box5_text2">{{ item.title ||"--" }} </div>
					<div class="box5_text2">{{ item.plaintiffs ||"--" }} </div>
					<div class="box5_text2">{{ item.defendants||"--" }} </div>
					<div class="box5_text2">{{ item.releaseTime||"--" }} </div>
					<div class="box5_text2">{{ item.court||"--" }}</div>
					<div class="box5_text2">{{ item.hearingDate||"--" }}</div>
					<div class="box5_text2 justify-center  width-80" style="flex:none;">
						<span class="cpoint" style="color: #0070c0;" @click="showDialog(item,'opennotice')">详情</span>
					</div>
				</div>
				<div class="padding-bottom-40" v-if="!opennotice_list.length">
					<nomore></nomore>
				</div>

				<div  class="text-right" style="padding: 10px 0">
					<el-pagination background :page-size="opennotice_group.pagesize" :page-sizes="pageSizes"
						:hide-on-single-page="false" layout="prev, pager, next,sizes"
						@size-change="handleSizeChange($event,'opennotice')"
						@current-change="handleCurrentChange($event,'opennotice')"
						:current-page="opennotice_group.currentPage" :total="opennotice_group.totalnum">
					</el-pagination>
				</div>
			</template>

			<template v-if="vctbIndex==3">
				<div class="box5 box2_cc">
					<div class="box5_text2 text-bold">立案案号</div>
					<div class="box5_text2 text-bold">原告身份</div>
					<div class="box5_text2 text-bold">被告身份 </div>
					<div class="box5_text2 text-bold">立案日期</div>
					<div class="box5_text2 text-bold">案件状态</div>
					<div class="box5_text2 text-bold">立案理由</div>
					<div class="box5_text2 text-bold">结案时间</div>
					<div class="box5_text2 text-bold justify-center width-80" style="flex:none;">案件详情</div>
				</div>
				<!-- detail.majorpeople -->
				<div v-for="(item, index) in filing_list" :key="index" class="box5">
					<div class="box5_text2"> {{ item.caseNo ||"--" }} </div>
					<div class="box5_text2"> {{ item.plaintiffs ||"--" }} </div>
					<div class="box5_text2">{{ item.defendants||"--" }} </div>
					<div class="box5_text2">{{ item.startDate||"--" }} </div>
					<div class="box5_text2">{{ item.caseStatus||"--" }}</div>
					<div class="box5_text2">{{ item.caseCause||"--" }}</div>
					<div class="box5_text2">{{ item.endDate||"--" }}</div>
					<div class="box5_text2 justify-center width-80" style="flex:none;">
						<span class="cpoint" style="color: #0070c0;" @click="showDialog(item,'filing')">详情</span>
					</div>
				</div>
				<div class="padding-bottom-40" v-if="!filing_list.length">
					<nomore></nomore>
				</div>

				<div class="text-right" style="padding: 10px 0">
					<el-pagination background :page-size="filing_group.pagesize" :page-sizes="pageSizes"
						:hide-on-single-page="false" layout="prev, pager, next,sizes"
						@size-change="handleSizeChange($event,'filing')"
						@current-change="handleCurrentChange($event,'filing')" :current-page="filing_group.currentPage"
						:total="filing_group.totalnum">
					</el-pagination>
				</div>

			</template>
		</div>



		<el-dialog title="裁判文书详情" :visible.sync="document_group.show">
			<scroll-view scrollY height="70vh">
				<table class="pure-table pure-table-bordered">
					<tbody>
						<tr>
							<td style="width:40%;background: #F7F7F7;">案件名称</td>
							<td>{{document_group.showData.title||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">案件类型</td>
							<td>{{document_group.showData.type||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">裁判发布日期</td>
							<td>
								{{ document_group.showData.date?dayjs(Number(document_group.showData.date)*1000).format('YYYY-MM-DD')  :"--" }}
							</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">裁判文书类型</td>
							<td>{{document_group.showData.docType||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">法院名称</td>
							<td>{{document_group.showData.court||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">法官姓名</td>
							<td>{{document_group.showData.judgeName||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">案件编号</td>
							<td>{{document_group.showData.caseNo||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">当事人信息</td>
							<td>
								<div>原告:{{document_group.showData.plaintiffs||"--" }}</div>
								<!-- <div>原告委托代理人:{{courtnotice_group.showData.type||"--" }}</div> -->
								<div>被告:{{document_group.showData.defendants||"--" }}</div>
								<!-- <div>被告委托代理人:{{courtnotice_group.showData.type||"--" }}</div> -->
							</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">相关人/单位</td>
							<td>{{document_group.showData.parties||"--" }}</td>
						</tr>

						<tr>
							<td style=" background: #F7F7F7;">案由关键字</td>
							<td>{{document_group.showData.caseCause||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">正文内容</td>
							<td>{{document_group.showData.text||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">审批流程</td>
							<td>{{document_group.showData.processForSearch||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">法院裁判结果</td>
							<td>{{document_group.showData.judgeResult||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">裁判日期</td>
							<td>{{document_group.showData.date||"--" }}</td>
						</tr>
					</tbody>
				</table>
			</scroll-view>
		</el-dialog>

		<el-dialog title="法院公告详情" :visible.sync="courtnotice_group.show">
			<scroll-view scrollY height="70vh">
				<table class="pure-table pure-table-bordered">
					<tbody>
						<tr>
							<td style="width:200px;background: #F7F7F7;">当事人信息</td>
							<td>
								<!-- <div>原告:{{courtnotice_group.showData.plaintiffs||"--" }}</div>
								<div>原告委托代理人:{{courtnotice_group.showData.type||"--" }}</div>
								<div>被告:{{courtnotice_group.showData.defendants||"--" }}</div>
								<div>被告委托代理人:{{courtnotice_group.showData.type||"--" }}</div> -->
								<div>{{courtnotice_group.showData.personInfo||"--" }}</div>
							</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">法院公告类型</td>
							<td>{{courtnotice_group.showData.type||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">公告人</td>
							<td>{{courtnotice_group.showData.court||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">法院公告日期</td>
							<td>{{courtnotice_group.showData.date||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">法院公告内容</td>
							<td>{{courtnotice_group.showData.content||"--" }}</td>
						</tr>
					</tbody>
				</table>
			</scroll-view>
		</el-dialog>
		<el-dialog title="开庭公告详情" :visible.sync="opennotice_group.show">
			<scroll-view scrollY height="70vh">
				<table class="pure-table pure-table-bordered">
					<tbody>
						<tr>
							<td style=" background: #F7F7F7;">案件名称</td>
							<td>{{opennotice_group.showData.title||"--" }}</td>
						</tr>
						<tr>
							<td style="width:200px;background: #F7F7F7;">当事人信息</td>
							<td>
								<!-- <div>原告:{{opennotice_group.showData.plaintiffs||"--" }}</div>
								<div>原告委托代理人:{{opennotice_group.showData.type||"--" }}</div>
								<div>被告:{{opennotice_group.showData.defendants||"--" }}</div>
								<div>被告委托代理人:{{opennotice_group.showData.type||"--" }}</div> -->
								<div>{{opennotice_group.showData.personInfo||"--" }}</div>
							</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">开庭公告发布日期</td>
							<td>{{opennotice_group.showData.releaseTime||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">公告人</td>
							<td>{{opennotice_group.showData.court||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">开庭日期 (开庭公告)</td>
							<td>{{opennotice_group.showData.hearingDate||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">开庭法院名称</td>
							<td>{{opennotice_group.showData.tribunal||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">关联案号</td>
							<td>{{opennotice_group.showData.caseNo||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">开庭公告内容</td>
							<td>{{opennotice_group.showData.content||"--" }}</td>
						</tr>
					</tbody>
				</table>
			</scroll-view>
		</el-dialog>
		<el-dialog title="开庭公告详情" :visible.sync="filing_group.show">
			<scroll-view scrollY height="70vh">
				<table class="pure-table pure-table-bordered">
					<tbody>
						<tr>
							<td style=" background: #F7F7F7;">立案案号</td>
							<td>{{filing_group.showData.caseNo||"--" }}</td>
						</tr>
						<tr>
							<td style="width:200px;background: #F7F7F7;">当事人信息</td>
							<td>
								<!-- <div>原告:{{filing_group.showData.plaintiffs||"--" }}</div>
								<div>原告委托代理人:{{filing_group.showData.type||"--" }}</div>
								<div>被告:{{filing_group.showData.defendants||"--" }}</div>
								<div>被告委托代理人:{{filing_group.showData.type||"--" }}</div> -->
								<div>{{filing_group.showData.personInfo||"--" }}</div>
							</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">相关人/单位</td>
							<td>{{filing_group.showData.parties||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">立案日期</td>
							<td>{{filing_group.showData.startDate||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">案件状态</td>
							<td>{{filing_group.showData.caseStatus||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">立案案由</td>
							<td>{{filing_group.showData.caseCause||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">结案时间</td>
							<td>{{filing_group.showData.endDate||"--" }}</td>
						</tr>
						<tr>
							<td style="hearingDate">开庭日期 (立案信息)</td>
							<td>{{filing_group.showData.content||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">立案法院名称</td>
							<td>{{filing_group.showData.court||"--" }}</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;">立案地区</td>
							<td>{{filing_group.showData.region||"--" }}</td>
						</tr>
					</tbody>
				</table>
			</scroll-view>
		</el-dialog>
	</div>

</template>

<script>
	import dayjs from "dayjs"
	export default {
		name: "judicial-page",
		props: {
			id: {
				type: [String, Number],
				default: ""
			},
			detail: {
				type: Object,
				default: ""
			}
		},
		data() {
			return {
				courtnotice_list: [],
				courtnotice_group: {
					currentPage: 1,
					pagesize: 15,
					type: 0,
					totalnum: 0,
					show: false,
					showData: {}
				},
				document_list: [],
				document_group: {
					currentPage: 1,
					pagesize: 15,
					type: 0,
					totalnum: 0,
					show: false,
					showData: {}
				},

				opennotice_list: [],
				opennotice_group: {
					currentPage: 1,
					pagesize: 15,
					type: 0,
					totalnum: 0,
					show: false,
					showData: {}
				},
				filing_list: [],
				filing_group: {
					currentPage: 1,
					pagesize: 15,
					type: 0,
					totalnum: 0,
					show: false,
					showData: {}
				},
				checkShow: false,
				vctbIndex: 0,
				pageSizes: [10, 20, 30, 40, 50],

			}
		},
		methods: {
			dayjs,
			showDialog(e, key) {
				this[`${key}_group`].showData = e
				this[`${key}_group`].show = true;
				console.log(`${key}_group`, this[`${key}_group`])
			},
			getdocumentList() {
				var api = this.$api.api.interfacenew.document_list;
				this.$https.post({
						api: api,
						type: "formData",
					}, {
						start: this.document_group.currentPage,
						page_size: this.document_group.pagesize,
						id: this.id
					},
					(response) => {
						this.document_list = response.data;
						this.document_group.totalnum = response.count;

					},
					(error) => {
						// console.log(error);
					}
				);
			},
			getcourtnoticeList() {
				var api = this.$api.api.interfacenew.courtnotice_list;
				this.$https.post({
						api: api,
						type: "formData",
					}, {
						start: this.courtnotice_group.currentPage,
						page_size: this.courtnotice_group.pagesize,
						id: this.id
					},
					(response) => {
						this.courtnotice_list = response.data;
						this.courtnotice_group.totalnum = response.count;

					},
					(error) => {
						// console.log(error);
					}
				);
			},
			getopennoticeList() {
				var api = this.$api.api.interfacenew.opennotice_list;
				this.$https.post({
						api: api,
						type: "formData",
					}, {
						start: this.opennotice_group.currentPage,
						page_size: this.opennotice_group.pagesize,
						id: this.id
					},
					(response) => {
						this.opennotice_list = response.data;
						this.opennotice_group.totalnum = response.count;

					},
					(error) => {
						// console.log(error);
					}
				);
			},
			getfilingList() {
				var api = this.$api.api.interfacenew.filing_list;
				this.$https.post({
						api: api,
						type: "formData",
					}, {
						start: this.filing_group.currentPage,
						page_size: this.filing_group.pagesize,
						id: this.id
					},
					(response) => {
						this.filing_list = response.data;
						this.filing_group.totalnum = response.count;

					},
					(error) => {
						// console.log(error);
					}
				);
			},
			getNumber() {
				let num = 0
				if (this.filing_group.totalnum) num += this.filing_group.totalnum;
				if (this.opennotice_group.totalnum) num += this.opennotice_group.totalnum;
				if (this.courtnotice_group.totalnum) num += this.courtnotice_group.totalnum;
				if (this.document_group.totalnum) num += this.opennotice_group.totalnum;
				this.$emit("rNum", num)
			},
			handleCurrentChange(currentPage, key) {
				this[`${key}_group`].currentPage = currentPage;
				if (this.vctbIndex == 0) this.getdocumentList();
				else if (this.vctbIndex == 1) this.getcourtnoticeList();
				else if (this.vctbIndex == 2) this.getopennoticeList();
				else if (this.vctbIndex == 3) this.getfilingList();
			},
			handleSizeChange(size, key) {
				this[`${key}_group`].pagesize = size;
				this[`${key}_group`].currentPage = 1;
				if (this.vctbIndex == 0) this.getdocumentList();
				else if (this.vctbIndex == 1) this.getcourtnoticeList();
				else if (this.vctbIndex == 2) this.getopennoticeList();
				else if (this.vctbIndex == 3) this.getfilingList();
			},toout(href) {
				// console.log(href)
				if (!href) {
					return false;
				}
				window.open(href)
			},
		},
		created() {
			this.getdocumentList();
			this.getcourtnoticeList();
			this.getopennoticeList();
			this.getfilingList();
		}
	}
</script>

<style lang="scss" scoped>
	@import '../detailcss.scss';
</style>



// WEBPACK FOOTER //
// judicial-page.vue?52654129